import { render, staticRenderFns } from "./ContextMenu.vue?vue&type=template&id=8a5978ae&lang=pug&"
import script from "./ContextMenu.ts?vue&type=script&lang=ts&"
export * from "./ContextMenu.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports